'use client';

import React from 'react';

import LandingLessonCard from './landingLessonCard';

import { Skeleton } from '@/components/ui/skeleton';
import useNewestEducationContent from '@/hooks/queries/useNewestEducationContent';

const LandingNewest: React.FC = () => {
  const { data: newestEducationContent, isFetched } =
    useNewestEducationContent();

  if (isFetched && !newestEducationContent) {
    return null;
  }

  if (newestEducationContent) {
    return (
      <LandingLessonCard lesson={newestEducationContent} hasIcon={false} />
    );
  }

  return <Skeleton className="aspect-16/10 w-full rounded-xl" />;
};

export default LandingNewest;
